import React from 'react';
import { SITE_CONSTANTS } from '../../../utils/constants';
import Picture from '../../Picture';

import './TrustedByCompanies.scss';



const TrustedByCompanies = ({ isAIPage }) => {

  const logos = [
    { src: "/images/site/customers/mtx.png", alt: "MTX logo" },
    { src: "/images/site/customers/tagima.png", alt: "Tagima logo" },
    { src: "/images/site/customers/mili.png", alt: "Mili logo" },
    { src: "/images/site/customers/berwanger.png", alt: "Berwanger logo" },
    { src: "/images/site/customers/anasol-cor.png", alt: "Anasol logo" },
    { src: "/images/site/customers/gelopar.png", alt: "Gelopar logo" },
    { src: "/images/site/customers/hprime.png", alt: "HPrime logo" }
  ];

  const TitleComponent = isAIPage ? 'p' : 'h3';

  return (
    <div className="trusted-by-companies-section">
      <TitleComponent className="trusted-by-title">
        <span className="trusted-by-text-bold">{SITE_CONSTANTS.CLIENTS_COUNT_WITH_PLUS} empresas</span>
        <span className="trusted-by-text-regular"> confiam na Mercos</span>
      </TitleComponent>
      <div className="trusted-by-logos-grid">
        {logos.map((logo, index) => (
          <div className="trusted-by-logo-item" key={index}>
            <Picture src={logo.src} alt={logo.alt} className="trusted-by-logo-image" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustedByCompanies;


// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/custom/TrustedByCompanies.jsx